<ng-container *ngIf="application">
  <div class="real-property-item" [routerLink]="['/real-property', application.applicationId]">
    <div class="photo">
      <app-no-photo *ngIf="!application.photoIdList || application.photoIdList?.length === 0; else hasPhoto"
        [objectId]="application.applicationId">
      </app-no-photo>
      <ng-template #hasPhoto>
        <img class="image-with-data" [src]="getPath(application.photoIdList[0])" alt="">
      </ng-template>
    </div>
    <div class="p-d-flex p-flex-column real-property-info">

      <div class="p-d-flex p-ai-center residential-complex">
        <span [title]="application.residentialComplexName"
          *ngIf="application.residentialComplexName; else nullResidentialComplex">
          ЖК {{application.residentialComplexName}}
        </span>

        <ng-template #nullResidentialComplex>
          <span>
            Район <app-name [name]="application.address"></app-name>
          </span>
        </ng-template>
      </div>

      <div class="p-d-flex p-ai-center specs">
        <ng-container *ngIf="application.numberOfRooms && application.objectType.id">
          <ng-container [ngSwitch]="application.objectType.id">
            <span class="room">
              <ng-container *ngSwitchCase="1">
                {{application.numberOfRooms}} комнатная
              </ng-container>
              <ng-container *ngSwitchCase="2">
                {{application.numberOfRooms}} комнатный
              </ng-container>
            </span>
          </ng-container>
        </ng-container>


        <ng-container *ngIf="application.totalArea">
          <div class="total-area">
            <div class="separator"></div>
            {{application.totalArea}}м<sup><small>2</small></sup>
          </div>
        </ng-container>
        <ng-container *ngIf="application.floor && application.numberOfFloors">
          <div class="number-floors">
            <div class="separator"></div>
            {{application.floor}} из {{application.numberOfFloors}}
          </div>
        </ng-container>

      </div>

      <div class="p-d-flex p-ai-center price">
        <span>
          {{application.objectPrice | mask: 'separator.2'}} ₸
        </span>
      </div>

    </div>
  </div>
</ng-container>